export default "__VITE_ASSET__CQk8lIn9__"